/** Desabilita temporariamente a API de transportadoras (problema no backend). */
export const TRANSPORTADORAS_API_ENABLED = false;

/** Chaves de sessionStorage usadas no atendimento avulso */
export const SESSION_KEYS = {
  COND_PGTO: "condPagamentos",
  VENDEDORES: "vendedores",
  PRODUTOS_SHELL: "crmProdutosShell",
  TRANSPORTADORAS: "transportadoras",
};

export function contatosSessionKey(cliente, loja = "01") {
  return `contatos_${String(cliente)}_${String(loja || "01")}`;
}

export function readSessionJson(key, fallback = null) {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null || raw === "") return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeSessionJson(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

/** Extrai lista de respostas Protheus/Workflow com formatos variados */
export function extractList(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;

  if (typeof data === "object") {
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.produtos)) return data.produtos;
    if (Array.isArray(data.vendedores)) return data.vendedores;
    if (Array.isArray(data.condicoes)) return data.condicoes;
    if (Array.isArray(data.condpagamentos)) return data.condpagamentos;
    if (Array.isArray(data.condPagamentos)) return data.condPagamentos;
    if (Array.isArray(data.CONDPGTO)) return data.CONDPGTO;
    if (Array.isArray(data.INT_CRM_APP_CONDPGTO))
      return data.INT_CRM_APP_CONDPGTO;

    // Objeto único no formato da condição de pagamento
    if (data.codigo != null && (data.descricao != null || data.DESCRICAO != null)) {
      return [data];
    }

    // Procura o primeiro array de objetos com "codigo" ou "codigo_vededor"
    for (const value of Object.values(data)) {
      if (
        Array.isArray(value) &&
        value.length > 0 &&
        typeof value[0] === "object" &&
        value[0] != null &&
        (value[0].codigo != null ||
          value[0].CODIGO != null ||
          value[0].codigo_vededor != null ||
          value[0].codigo_vendedor != null)
      ) {
        return value;
      }
    }

    // Qualquer array de objetos
    for (const value of Object.values(data)) {
      if (
        Array.isArray(value) &&
        value.length > 0 &&
        typeof value[0] === "object"
      ) {
        return value;
      }
    }
  }

  return [];
}

export function normalizeCondPgtoList(data) {
  return extractList(data)
    .map((item) => {
      const codigo = String(
        item.codigo ??
          item.CODIGO ??
          item.e4_codigo ??
          item.E4_CODIGO ??
          "",
      ).trim();
      const descricao = String(
        item.descricao ??
          item.DESCRICAO ??
          item.e4_descri ??
          item.E4_DESCRI ??
          item.nome ??
          "",
      ).trim();
      const dias_pgto = String(
        item.dias_pgto ??
          item.DIAS_PGTO ??
          item.dias ??
          item.e4_dias ??
          "",
      ).trim();
      const parcelas = Number(
        item.parcelas ??
          item.PARCELAS ??
          item.e4_parcelas ??
          item.E4_PARCELAS ??
          1,
      );
      return {
        ...item,
        codigo,
        descricao,
        dias_pgto,
        parcelas: Number.isFinite(parcelas) && parcelas > 0 ? parcelas : 1,
      };
    })
    .filter((item) => item.codigo !== "");
}

export function formatCondPgtoLabel(opt) {
  if (!opt) return "";
  const codigo = String(opt.codigo || "").trim();
  const descricao = String(opt.descricao || "").trim();
  const dias = String(opt.dias_pgto ?? "").trim();
  const base = [codigo, descricao].filter(Boolean).join(" — ");
  if (dias !== "" && dias !== "00") {
    return `${base} (${dias} dias)`;
  }
  if (dias === "00") {
    return base;
  }
  return base || codigo;
}

export function normalizeVendedoresList(data) {
  return extractList(data)
    .map((item) => {
      const codigo = String(
        item.codigo_vededor ??
          item.codigo_vendedor ??
          item.CODIGO_VEDEDOR ??
          item.CODIGO_VENDEDOR ??
          item.codigo ??
          item.CODIGO ??
          item.a3_cod ??
          item.A3_COD ??
          "",
      ).trim();
      const nome = String(
        item.nome_vededor ??
          item.nome_vendedor ??
          item.NOME_VEDEDOR ??
          item.NOME_VENDEDOR ??
          item.nome ??
          item.NOME ??
          item.a3_nome ??
          item.A3_NOME ??
          item.descricao ??
          "",
      ).trim();
      return {
        ...item,
        codigo,
        nome,
        cidade: item.cidade ?? item.CIDADE ?? "",
        estado: item.estado ?? item.ESTADO ?? "",
        endereco: item.endereco ?? item.ENDERECO ?? "",
      };
    })
    .filter((item) => item.codigo !== "");
}

export function formatVendedorLabel(v) {
  if (!v) return "";
  const codigo = String(v.codigo || "").trim();
  const nome = String(v.nome || "").trim();
  const cidade = String(v.cidade || "").trim();
  const estado = String(v.estado || "").trim();
  const base = [codigo, nome].filter(Boolean).join(" — ");
  if (cidade || estado) {
    return `${base} (${[cidade, estado].filter(Boolean).join("/")})`;
  }
  return base || codigo;
}

export function normalizeProdutosShellList(data) {
  return extractList(data)
    .map((item) => ({
      ...item,
      codigo: String(
        item.codigo ??
          item.CODIGO ??
          item.b1_cod ??
          item.B1_COD ??
          "",
      ).trim(),
      nome: String(
        item.nome ??
          item.NOME ??
          item.b1_desc ??
          item.B1_DESC ??
          item.descricao ??
          item.DESCRICAO ??
          "",
      ).trim(),
      descricao: String(
        item.descricao ??
          item.DESCRICAO ??
          item.nome ??
          item.NOME ??
          "",
      ).trim(),
      unidade: item.unidade ?? item.UNIDADE ?? item.um ?? "",
      tipo: item.tipo ?? item.TIPO ?? "",
      estoque: item.estoque ?? item.ESTOQUE ?? 0,
      ncm: item.ncm ?? item.NCM ?? "",
    }))
    .filter((item) => item.codigo !== "");
}

export function normalizeTransportadorasList(data) {
  return extractList(data)
    .map((item) => {
      const codigo = String(
        item.codigo ?? item.CODIGO ?? item.a4_cod ?? item.A4_COD ?? "",
      ).trim();
      const nome = String(
        item.nome ?? item.NOME ?? item.a4_nome ?? item.A4_NOME ?? "",
      ).trim();
      const nomefantasia = String(
        item.nomefantasia ??
          item.NOMEFANTASIA ??
          item.nome_fantasia ??
          item.a4_nreduz ??
          "",
      ).trim();
      return {
        ...item,
        codigo,
        nome,
        nomefantasia,
      };
    })
    .filter((item) => item.codigo !== "");
}

export function formatTransportadoraLabel(t) {
  if (!t) return "";
  const codigo = String(t.codigo || "").trim();
  const nome = String(t.nome || "").trim();
  const fantasia = String(t.nomefantasia || "").trim();
  if (fantasia && fantasia !== nome) {
    return `${codigo} — ${nome} (${fantasia})`;
  }
  return [codigo, nome].filter(Boolean).join(" — ") || codigo;
}

/** Cache válido só se existir e tiver ao menos 1 item */
export function hasCachedList(key) {
  const list = readSessionJson(key);
  return Array.isArray(list) && list.length > 0;
}

export function hasCachedCatalogos() {
  const base =
    hasCachedList(SESSION_KEYS.COND_PGTO) &&
    hasCachedList(SESSION_KEYS.VENDEDORES) &&
    hasCachedList(SESSION_KEYS.PRODUTOS_SHELL);
  if (!TRANSPORTADORAS_API_ENABLED) return base;
  return base && hasCachedList(SESSION_KEYS.TRANSPORTADORAS);
}
